<div class="hudsonMilkTheme">
<ng-container *ngIf="!!featureTags && !featureTags['sf_mobile_view_issue_2']">
<footer class="bg-primary footer" *ngIf="router.url !== '/edit-order'  &&  router.url !== '/account/orders'  && 
    router.url !== '/account/addresses' && router.url !== '/account/payment/add-credit-card' && !router.url.includes('account-setup')"
    [class.isHundsunMilkFooter]="isHMTheme">
    <!-- <div *ngIf = "storeDetailsJson['settings'] && storeDetailsJson['settings']['subscriptionForm'] === true" fxLayout="column" fxLayout.gt-sm="row wrap" fxLayoutAlign="center center" class="border-bottom-mute subscribe-block theme-container">
        <div fxFlex="100" fxFlex.gt-sm="40" fxLayout="column" fxLayoutAlign="center center"> 
            <h1 class="fw-500">Subscribe our Newsletter</h1>
            <h3 class="fw-300 secondary-color">Stay up to date with our latest new and products</h3>
        </div>
        <form method="get" class="subscribe-search-form" fxLayout="row" fxFlex="100" fxFlex.gt-sm="42.4" ngClass.sm="mt-2" ngClass.xs="mt-2">
            <input type="text" placeholder="Your email address..." fxFlex>
            <button mat-raised-button col   or="accent" (click)="subscribe()" type="button" class="mat-elevation-z0 text-muted">Subscribe</button>
        </form>
    </div> -->
    <div [fxHide.xs]="loggedIn" fxLayout="row wrap" fxLayout.lg="row nowrap" fxLayoutAlign="space-between" class="py-2 border-bottom-mute theme-container">
        <div fxLayoutGap="15px" fxLayout="row" fxLayout.xs="column" fxFlex.md="100"
            ngClass.sm="mt-2" ngClass.xs="mt-2" *ngIf="storeDetailsJson['footer']">
            <!-- <agm-map [latitude]="lat" [longitude]="lng" [zoom]="zoom" [mapTypeControl]="true">
                <agm-marker [latitude]="lat" [longitude]="lng" [markerDraggable]="true"></agm-marker>
            </agm-map> -->
            <div fxLayout="column" *ngIf="!!featureTags && !featureTags['sf_cms_images']">
                <img src="{{storeDetailsJson['footer']['logos']['logoImage1']}}" class="footer-logo" alt="Logo" />
                <img *ngIf="!isHMTheme" src="{{storeDetailsJson['footer']['logos']['logoImage2']}}" class="footer-logo"
                    alt="Logo" />
            </div>
            <div fxLayout="column" *ngIf="!!featureTags && featureTags['sf_cms_images']">
                <img src="assets/hudson/files/images/3/content-images/invoice_logo.jpg" class="footer-logo" alt="Logo" />
            </div>
            <div *ngIf="isHMTheme; else freeDelivery">
                <ul class="HMaddress">
                    <li *ngFor="let con of storeDetailsJson['footer']['address']">
                        <a [fxShow]="con.link" [href]="'mailto:'+con.label">{{con.label}}</a>
                        <span [fxHide]="con.link">{{con.label}}</span>
                    </li>
                </ul>
            </div>
            <ng-template #freeDelivery>
                <div>
                    <h2>{{storeDetailsJson['footer']['description']['title']}}</h2>
                    <p class="mt-2 secondary-color">{{storeDetailsJson['footer']['description']['description']}}</p>
                    <div class=" py-2" fxHide.lt-sm="true" fxLayoutAlign="end">
                        <a href="https://www.facebook.com/CowBelleHomeMilkDelivery" target="_blank">
                            <img class="social-icon" src="assets/images/facebook_icon.png" alt="Facebook Icon">
                        </a>
                    </div>
                </div>
            </ng-template>
        </div>
        <div [fxHide]="!isHMTheme" fxFlex="100" fxFlex.gt-sm="25" fxFlex.sm="60" fxFlex.md="50" ngClass.xs="mt-2"
            class="contact-information p-1">
            <h3 class="col-title">CONTACT INFORMATION</h3>
            <p fxLayout="row" fxLayoutAlign="start center" class="mt-1 secondary-color">
                <i class="material-icons" data-icon="location_on"></i>
                <span>{{storeDetails['address']}}</span>
            </p>
            <p fxLayout="row" fxLayoutAlign="start center" class="mt-1 secondary-color">
                <i class="material-icons" data-icon="call"></i>
                <span>{{storeDetails['phone'] | phone: 'US'}}</span>
            </p>
            <p fxLayout="row" fxLayoutAlign="start center" class="mt-1 secondary-color">
                <i class="material-icons" data-icon="schedule"></i>
                <span>Mon - Fri / 8:00AM - 6:00PM</span>
            </p>
            <p fxLayout="row" fxLayoutAlign="start center" class="mt-1 secondary-color">
                <i class="material-icons" data-icon="mail_outline"></i>
                <span>{{storeDetails['reply_to_email']}}</span>                
            </p>
            <!-- <p fxLayout="row" fxLayoutAlign="start center" class="mt-1 secondary-color">
                <mat-icon>directions</mat-icon>
                <a href="javascript:void(0);" class="link secondary-color">Get directions</a>
            </p>
            <p fxLayout="row" fxLayoutAlign="start center" class="mt-1 secondary-color">
                <mat-icon>directions_bus</mat-icon>
                <span>Routes to us</span>
            </p> -->
        </div>
        <div [fxHide]="!isHMTheme" class="p-1" fxFlex="100" fxFlex.gt-sm="16.6666" fxFlex.md="50" fxFlex.sm="40"
            *ngIf="storeDetailsJson['footer']">
            <h3 class="col-title">{{storeDetailsJson['footer']['customerLinks']['title']}}</h3>
            <p class="mt-7px" *ngFor="let link of storeDetailsJson['footer']['customerLinks']['links']">
                <a [routerLink]="['/', link['href']]" class="link secondary-color"
                    [title]="link['label']">{{link['label']}}</a>

            </p>
        </div>
        <div [fxHide]="!isHMTheme" class="p-1" fxFlex="100" fxFlex.gt-sm="16.6666" fxFlex.md="50" fxFlex.sm="40"
            *ngIf="storeDetailsJson['footer']">
            <h3 class="col-title">{{storeDetailsJson['footer']['aboutLinks']['title']}}</h3>
            <p class="mt-7px" *ngFor="let link of storeDetailsJson['footer']['aboutLinks']['links']">
                <a [routerLink]="['/', link['href']]" class="link secondary-color">{{link['label']}}</a>
            </p>
        </div>
        <div [fxHide]="!isHMTheme" class="p-1" fxFlex="100" fxFlex.gt-sm="16.6666" fxFlex.md="50" fxFlex.sm="40"
            *ngIf="storeDetailsJson['footer']">
            <h3 class="col-title">{{storeDetailsJson['footer']['accountLinks']['title']}}</h3>
            <p class="mt-7px" *ngFor="let link of storeDetailsJson['footer']['accountLinks']['links']">
                <a (click)="navigateTo(link.href)" class="link secondary-color">{{link['label']}}</a>
            </p>
        </div>
    </div>
    <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-between center"
        class="copyright secondary-color theme-container">
        <div fxLayout.xs="column" fxLayoutGap.xs="12px" fxLayoutAlign.xs="center center"
         fxLayout="row" fxFlex="100" fxLayoutAlign="space-between center" *ngIf="isHMTheme; else copyRight">
            <p *ngIf="storeDetailsJson['second_footer']" ngClass.xs="mt-1">
                {{storeDetailsJson['second_footer']['copyRight']['copyRightText']}}
            </p>
            <div class="socialIcons">
                <ul class="list-inline" fxLayout="row" fxLayoutGap="15px">
                    <li *ngFor="let x of storeDetailsJson['socialMedia']">
                        <a [href]="x.href" target="_blank">
                            <i [class]="'fa fa-'+x.icon" aria-label="socialmedia"></i>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <ng-template #copyRight>
            <p *ngIf="storeDetailsJson['second_footer']" ngClass.xs="mt-1">
                {{storeDetailsJson['second_footer']['copyRight']['copyRightText']}}</p>
        </ng-template>
    </div>
</footer>
<footer class="bg-primary footer footer-excep" *ngIf="router.url === '/edit-order' ||  router.url === '/account/orders' || 
    router.url === '/account/addresses' || router.url === '/account/payment/add-credit-card' || router.url.includes('account-setup')"
    [class.isHundsunMilkFooter]="isHMTheme">
    <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-between center"
        class="copyright secondary-color theme-container">
        <p *ngIf="storeDetailsJson['second_footer']" ngClass.xs="mt-1">
            {{storeDetailsJson['second_footer']['copyRight']['copyRightText']}}</p>
    </div>
</footer>
</ng-container>
<ng-container *ngIf="!!featureTags && featureTags['sf_mobile_view_issue_2']">
    <footer class="bg-primary footer" *ngIf="!loggedIn"
    [class.isHundsunMilkFooter]="isHMTheme"
    [class.hudsonfooterNoPadding]="!loggedIn">
    <div [fxHide.xs]="loggedIn" fxLayout="row wrap" fxLayout.lg="row nowrap" fxLayoutAlign="space-between" class="py-2 border-bottom-mute theme-container">
        <div fxLayoutGap="15px" fxLayout="row" fxLayout.xs="column" fxFlex.md="100"
            ngClass.sm="mt-2" ngClass.xs="mt-2" *ngIf="storeDetailsJson['footer']">            
            <div fxLayout="column" *ngIf="!!featureTags && !featureTags['sf_cms_images']">
                <img src="{{storeDetailsJson['footer']['logos']['logoImage1']}}" class="footer-logo" alt="Logo" />
                <img *ngIf="!isHMTheme" src="{{storeDetailsJson['footer']['logos']['logoImage2']}}" class="footer-logo"
                    alt="Logo" />
            </div>
            <div fxLayout="column" *ngIf="!!featureTags && featureTags['sf_cms_images']">
                <img src="assets/hudson/files/images/3/content-images/invoice_logo.jpg" class="footer-logo" alt="Logo" />
            </div>
            <div *ngIf="isHMTheme; else freeDelivery">
                <ul class="HMaddress">
                    <li *ngFor="let con of storeDetailsJson['footer']['address']">
                        <a [fxShow]="con.link" [href]="'mailto:'+con.label">{{con.label}}</a>
                        <span [fxHide]="con.link">{{con.label}}</span>
                    </li>
                </ul>
            </div>
            <ng-template #freeDelivery>
                <div>
                    <h2>{{storeDetailsJson['footer']['description']['title']}}</h2>
                    <p class="mt-2 secondary-color">{{storeDetailsJson['footer']['description']['description']}}</p>
                    <div class=" py-2" fxHide.lt-sm="true" fxLayoutAlign="end">
                        <a href="https://www.facebook.com/CowBelleHomeMilkDelivery" target="_blank">
                            <img class="social-icon" src="assets/images/facebook_icon.png" alt="Facebook Icon">
                        </a>
                    </div>
                </div>
            </ng-template>
        </div>
        <div [fxHide]="!isHMTheme" fxFlex="100" fxFlex.gt-sm="25" fxFlex.sm="60" fxFlex.md="50" ngClass.xs="mt-2"
            class="contact-information p-1">
            <h3 class="col-title">CONTACT INFORMATION</h3>
            <p fxLayout="row" fxLayoutAlign="start center" class="mt-1 secondary-color">
                <i class="material-icons" data-icon="location_on"></i>
                <span>{{storeDetails['address']}}</span>
            </p>
            <p fxLayout="row" fxLayoutAlign="start center" class="mt-1 secondary-color">
                <i class="material-icons" data-icon="call"></i>
                <span>{{storeDetails['phone'] | phone: 'US'}}</span>
            </p>
            <p fxLayout="row" fxLayoutAlign="start center" class="mt-1 secondary-color">
                <i class="material-icons" data-icon="schedule"></i>
                <span>Mon - Fri / 8:00AM - 6:00PM</span>
            </p>
            <p fxLayout="row" fxLayoutAlign="start center" class="mt-1 secondary-color">
                <i class="material-icons" data-icon="mail_outline"></i>
                <span>{{storeDetails['reply_to_email']}}</span>                
            </p>            
        </div>
        <div [fxHide]="!isHMTheme" class="p-1" fxFlex="100" fxFlex.gt-sm="16.6666" fxFlex.md="50" fxFlex.sm="40"
            *ngIf="storeDetailsJson['footer']">
            <h3 class="col-title">{{storeDetailsJson['footer']['customerLinks']['title']}}</h3>
            <p class="mt-7px" *ngFor="let link of storeDetailsJson['footer']['customerLinks']['links']">
                <a [routerLink]="['/', link['href']]" class="link secondary-color"
                    [title]="link['label']">{{link['label']}}</a>

            </p>
        </div>
        <div [fxHide]="!isHMTheme" class="p-1" fxFlex="100" fxFlex.gt-sm="16.6666" fxFlex.md="50" fxFlex.sm="40"
            *ngIf="storeDetailsJson['footer']">
            <h3 class="col-title">{{storeDetailsJson['footer']['aboutLinks']['title']}}</h3>
            <p class="mt-7px" *ngFor="let link of storeDetailsJson['footer']['aboutLinks']['links']">
                <ng-container *ngIf="!!featureTags && featureTags['ftag_sf_manufacturer_list']">
                    <a [routerLink]="['/', link['href'] === 'vendors' ? 'producers' : link['href']]" class="link secondary-color">
                        {{ link['label'] }}
                      </a>
                </ng-container>
                <ng-container *ngIf="!!featureTags && !featureTags['ftag_sf_manufacturer_list']">
                    <a [routerLink]="['/', link['href']]" class="link secondary-color">{{link['label']}}</a>
                </ng-container>
            </p>
        </div>
        <div [fxHide]="!isHMTheme" class="p-1" fxFlex="100" fxFlex.gt-sm="16.6666" fxFlex.md="50" fxFlex.sm="40"
            *ngIf="storeDetailsJson['footer']">
            <h3 class="col-title">{{storeDetailsJson['footer']['accountLinks']['title']}}</h3>
            <p class="mt-7px" *ngFor="let link of storeDetailsJson['footer']['accountLinks']['links']">
                <a (click)="navigateTo(link.href)" class="link secondary-color">{{link['label']}}</a>
            </p>
        </div>
    </div>
    <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-between center"
        class="copyright secondary-color theme-container">
        <div fxLayout.xs="column" fxLayoutGap.xs="12px" fxLayoutAlign.xs="center center"
         fxLayout="row" fxFlex="100" fxLayoutAlign="space-between center" *ngIf="isHMTheme; else copyRight">
            <p *ngIf="storeDetailsJson['second_footer']" ngClass.xs="mt-1">
                {{storeDetailsJson['second_footer']['copyRight']['copyRightText']}}
            </p>
            <div class="socialIcons">
                <ng-container *ngIf="!!featureTags && featureTags['ftag_powered_by_fds']">
                    <a href="https://farmdeliverysoftware.com/" *ngIf="storeDetails.show_powered_by_link === 1" class="brandLink" target="_blank">Powered by Smart FDS</a>
                </ng-container>
                <ul class="list-inline" fxLayout="row" fxLayoutGap="15px">
                    <li *ngFor="let x of storeDetailsJson['socialMedia']">
                        <a [href]="x.href" target="_blank">
                            <i [class]="'fa fa-'+x.icon" aria-label="socialmedia"></i>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <ng-template #copyRight>
            <p *ngIf="storeDetailsJson['second_footer']" ngClass.xs="mt-1">
                {{storeDetailsJson['second_footer']['copyRight']['copyRightText']}}</p>
        </ng-template>
    </div>
</footer>
<footer class="bg-primary footer footer-excep" *ngIf="loggedIn"
    [class.isHundsunMilkFooter]="isHMTheme">
    <!-- [class.hudsonfooterNoPadding]="footerNoPadding" -->
    <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-between center"
        class="copyright secondary-color theme-container">
        <p *ngIf="storeDetailsJson['second_footer']" ngClass.xs="mt-1">
            {{storeDetailsJson['second_footer']['copyRight']['copyRightText']}}</p>
            <ng-container *ngIf="!!featureTags && featureTags['ftag_powered_by_fds']">
                <a href="https://farmdeliverysoftware.com/" *ngIf="storeDetails.show_powered_by_link === 1" class="brandLink" target="_blank">Powered by Smart FDS</a>
            </ng-container>
    </div>
</footer>
</ng-container>
</div>